export default __webpack_public_path__ + "static/media/delete-icon.b49d62b8.svg";